@use "../../../styles/breakpoint.module.scss" as *;

.confirmation {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
}

.body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

.grid {
    composes: safeGridContainer from "../../../styles/composable/layout.module.css";
}

.inner {
    grid-column: 1 / -1;

    @media ($above-tablet) {
        grid-column: 3 / span 8;
    }

    @media ($above-laptop) {
        grid-column: 4 / span 6;
    }
}

.heading {
    margin-block: var(--spacer-40);
    font: var(--font-h-40);
    text-align: center;
}
